module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container__card order-card",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "card"
    }
  }, [_c('div', {
    staticClass: "wrapper-position"
  }, [(_vm.brandLogo) ? _c('div', {
    staticClass: "brand-logo",
    attrs: {
      "id": "brand-logo"
    }
  }, [_c('img', {
    staticClass: "left-padding",
    attrs: {
      "src": _vm.brandLogo
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thank-you thank-you-content",
    attrs: {
      "id": "new-user-thankyou-content"
    }
  }, [_c('p', {
    style: (_vm.themeColor)
  }, [_vm._v("Thank you for subscribing")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23698158!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThankYouPage.vue
// module id = 73
// module chunks = 0